import React from "react";
import { Container, Row, Col, Button, Accordion } from "react-bootstrap";
import Slider from "react-slick";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const NextArrow = ({ onClick }) => (
  <div className="slider-arrow next" onClick={onClick}>
    <FaChevronRight />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="slider-arrow prev" onClick={onClick}>
    <FaChevronLeft />
  </div>
);

const ChitwanPackage = () => {

  const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div className="package-detail">

      {/* HERO BANNER */}
      <div
        className="package-hero-banner"
        style={{
          backgroundImage:
            "url('/Images/tour/Chitwan.jpg')",
        }}
      >
        <Container>
          <div className="hero-content">
            <h1>Chitwan Jungle Safari</h1>

            <p className="hero-subtitle">
              2 Nights / 3 Days • Wildlife Adventure Package
            </p>

            <div className="hero-price">
              Starting From <span>₹19,999</span> / Per Person
            </div>
          </div>
        </Container>
      </div>

      <Container className="package-container">

        {/* SLIDER + FORM */}
        <Row className="mb-4">

          {/* LEFT SLIDER */}
          <Col lg={8}>
            <div className="package-slider">
              <Slider {...sliderSettings}>
                <img src="/Images/tour/chitwan1.jpg" alt="" />
                <img src="/Images/tour/chitwan2.jpg" alt="" />
                <img src="/Images/tour/chitwan3.jpg" alt="" />
              </Slider>
            </div>
          </Col>

          {/* RIGHT FORM */}
          <Col lg={4}>
            <div className="enquiry-sidebar">
              <h2>₹19,999</h2>
              <p>Per Person</p>

              <Button variant="danger" className="mb-3">
                Book Now
              </Button>

              <form>
                <input type="text" placeholder="Your Name" />
                <input type="text" placeholder="Mobile Number" />
                <input type="date" />
                <input type="number" placeholder="Persons" />
                <textarea placeholder="Message"></textarea>

                <Button variant="dark">Send Enquiry</Button>
              </form>
            </div>
          </Col>

        </Row>

        {/* MAIN CONTENT */}
        <Row>
          <Col lg={8}>

            <div className="package-header">
              <h1>Chitwan Jungle Safari</h1>
              <p>2 Nights / 3 Days • Chitwan Wildlife Tour</p>
            </div>

            {/* Highlights */}
            <div className="content-box highlight-box">
              <h3>Tour Highlights</h3>

              <Row>
                <Col md={6}>✔ Jungle Safari Adventure</Col>
                <Col md={6}>✔ Elephant Breeding Center</Col>
                <Col md={6}>✔ Canoe Ride Experience</Col>
                <Col md={6}>✔ Tharu Cultural Dance Show</Col>
              </Row>
            </div>

            {/* Overview */}
            <div className="content-box">
              <h3>Overview</h3>
              <p>
                Explore the wilderness of Nepal with Chitwan Jungle Safari.
                Discover exotic wildlife, dense forests and traditional
                Tharu culture while enjoying thrilling jungle activities
                and peaceful natural surroundings.
              </p>
            </div>

            {/* Itinerary */}
            <div className="content-box">
              <h3>Day Wise Itinerary</h3>

              <Accordion defaultActiveKey="0">

                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    Day 1 – Arrival Chitwan
                  </Accordion.Header>
                  <Accordion.Body>
                    Arrival, hotel check-in and welcome cultural program
                    followed by Tharu dance performance.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    Day 2 – Jungle Activities
                  </Accordion.Header>
                  <Accordion.Body>
                    Jungle safari, canoe ride, elephant breeding center
                    visit and bird watching experience.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    Day 3 – Departure
                  </Accordion.Header>
                  <Accordion.Body>
                    Breakfast and transfer for onward journey
                    with unforgettable jungle memories.
                  </Accordion.Body>
                </Accordion.Item>

              </Accordion>
            </div>

            {/* Inclusion / Exclusion */}
            <div className="content-box">
              <Row>

                <Col md={6}>
                  <h4>Inclusions</h4>
                  <ul className="inclusion-list">
                    <li>Hotel Accommodation</li>
                    <li>Breakfast & Dinner</li>
                    <li>Jungle Safari Activities</li>
                    <li>Local Transfers</li>
                  </ul>
                </Col>

                <Col md={6}>
                  <h4>Exclusions</h4>
                  <ul className="exclusion-list">
                    <li>Personal Expenses</li>
                    <li>Insurance</li>
                    <li>Lunch</li>
                    <li>Camera Fees</li>
                  </ul>
                </Col>

              </Row>
            </div>

            {/* Gallery */}
            <div className="content-box">
              <h3>Gallery</h3>

              <Row className="gallery">
                <Col md={4}>
                  <img src="/Images/tour/chitwan1.jpg" alt="" />
                </Col>
                <Col md={4}>
                  <img src="/Images/tour/chitwan2.jpg" alt="" />
                </Col>
                <Col md={4}>
                  <img src="/Images/tour/chitwan3.jpg" alt="" />
                </Col>
              </Row>
            </div>

          </Col>
        </Row>

      </Container>
    </div>
  );
};

export default ChitwanPackage;